import { Directive } from '@angular/core';

/**
 * Leading slot inside an `rmaButton`. The spacing is carried by classes on the slot itself, not
 * by an `rma-icon` element selector, so a spinner, badge or avatar in the same slot spaces
 * identically to an icon. The 8px gap faces the label; the -4px pulls the glyph optically into
 * the button's padding. `rma-btn-prefix` is an inert marker with no CSS behind it.
 */
@Directive({
  selector: '[rmaButtonPrefix]',
  host: {
    class: 'rma-btn-prefix mr-2 -ml-1 inline-flex flex-none items-center',
  },
})
export class RmaButtonPrefixDirective {}

/** Trailing slot inside an `rmaButton`. The sibling of {@link RmaButtonPrefixDirective}. */
@Directive({
  selector: '[rmaButtonSuffix]',
  host: {
    class: 'rma-btn-suffix ml-2 -mr-1 inline-flex flex-none items-center',
  },
})
export class RmaButtonSuffixDirective {}
